var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"problem-box",on:{"click":function($event){return _vm.$router.push({ path: '/question' })}}},[_c('img',{attrs:{"src":require("@/assets/img/images/home/question.png"),"alt":"question"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }